import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { AsyncPipe, NgClass } from '@angular/common';
import { UploadsFilterComponent } from './uploads-filter/uploads-filter.component';
import { TableUploadsComponent } from './table-uploads/table-uploads.component';
import {
    B2bProgramFileUploadComponent,
    UploadRidersFileType,
} from './b2b-program-file-upload/b2b-program-file-upload.component';
import { RxEffects } from '@rx-angular/state/effects';
import { B2bLoadsState } from '../../../shared/state/b2b-loads-state';
import { Load } from '@api/models/B2bService/Contract/load';
import { ApiB2BListB2BLoadGet$Params } from '@api/fn/b-2-b/api-b-2-b-list-b-2-b-load-get';
import { StartWithUnit } from '@core/state/operators/start-with-unit';
import { B2BFile } from '@api/models/B2bService/Contract/b-2-b-file';
import { PushService } from '@core/push/push.service';
import { PushCodeModel } from '@core/push/push-code.model';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { HasPrivilege } from '@core/privileges/has-privilege';
import { PrivilegesModules } from '@core/privileges/privileges-modules';
import { getLoadingProp } from '@core/state/operators/start-with-loading';
import { PartnerProgram } from '@api/models/B2bService/Contract/partner-program';
import { B2bProgramType } from '../../../shared/models/b2b-program-type';
import {
    TableNumberOfTripsUploadsComponent,
} from './table-number-of-trips-uploads/table-number-of-trips-uploads.component';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'b2b-page-program-uploads',
    templateUrl: './program-uploads.component.html',
    styleUrls: ['./program-uploads.component.scss'],
    imports: [
        NgClass,
        UploadsFilterComponent,
        TableUploadsComponent,
        B2bProgramFileUploadComponent,
        AsyncPipe,
        TableNumberOfTripsUploadsComponent,
        TranslatePipe,
    ],
})
export class ProgramUploadsComponent {
    @HasPrivilege([PrivilegesModules.B2bPrtnr])
    public readonly isB2bPartnerEdit$: Observable<boolean>;

    public isEditUser$: Observable<boolean>;
    public b2bProgram: PartnerProgram;

    readonly #route: ActivatedRoute = inject(ActivatedRoute);
    readonly #push: PushService = inject(PushService);
    readonly #b2bLoadsState: B2bLoadsState = inject(B2bLoadsState);
    readonly #effects: RxEffects = inject(RxEffects);

    public readonly b2bProgramType: typeof B2bProgramType = B2bProgramType;
    public readonly loads$: Observable<Load[]> = this.#b2bLoadsState.loads$;
    public readonly pending$: Observable<boolean> = this.#b2bLoadsState.loading$.pipe(getLoadingProp(StartWithUnit.RequestB2BProgramLoads));

    public readonly pendingLoadFile$: Observable<boolean> = this.#b2bLoadsState.loading$.pipe(
        getLoadingProp(StartWithUnit.RequestB2BProgramUploadFile),
    );

    public readonly prgId: number = +this.#route.parent?.snapshot.paramMap.get(RoutingQueryParamsName.PrgId);

    public handlerFilterUploads(body: ApiB2BListB2BLoadGet$Params): void {
        this.#b2bLoadsState.requestLoads(body, this.b2bProgram.prgType);
    }

    public handlerLoadFile(body: { file: Blob; type: UploadRidersFileType }): void {
        this.#effects.register(
            this.#b2bLoadsState.requestUploadFileRiders(this.prgId, this.b2bProgram.prgType, body.file, body.type),
            (response: B2BFile) => {
                if (response.hasError > 0) {
                    this.#push.error(PushCodeModel.SuccessFileUploadWithError);
                } else {
                    this.#push.success(PushCodeModel.SuccessFileUpload);
                }
            },
        );
    }
}
